import React, {
    ChangeEvent,
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "hooks/redux";
import {
    applyGroup,
    applyTicker,
    copyGroup,
    copyTicker,
    deleteGroup,
    deleteTickerFromGroup,
    getGroups,
    getTickersByGroup,
} from "store/reducers/GroupsSlice";
import {
    changeTickerBlockStatus,
    getTickerSettings,
    resetTickerSettings,
    setSelectedGroup,
    setSelectedTicker,
    resetTicker,
    searchTickers,
} from "store/reducers/SettingsSlice";
import NewGroupModal from "components/NewGroupModal/NewGroupModal";
import AddTickerModal from "components/AddTickerModal/AddTickerModal";
import {
    CustomArrowExpand,
    CustomPlusCircled,
    ModalContentWrapper,
    SelectDiv,
    TickersSelectWrapper,
    TickersTitle,
    TitleText,
    TopElementsDiv,
} from "./savedSettingsBlockStyles";
import { SearchInput } from "components/Inputs/inputsStyles";
import AreYouSureModal from "components/AreYouSureModal/AreYouSureModal";
import CombineLogsModal from "components/CombineLogsModal/CombineLogsModal";
import { getLogsStatus, setLogsTickerName } from "store/reducers/LogsSlice";
import copyName from "utils/copyName/copyName";
import Loader from "components/Loader/Loader";
import WarningEditSessionModal from "components/SettingsModals/WarningEditSessionModal/WarningEditSessionModal";
import ExitEditSessionModal from "components/SettingsModals/ExitEditSessionModal/ExitEditSessionModal";
import errorNotification from "utils/Notifications/Error";
import { pathname } from "store/reducers/ActionCreators";
import Cookies from "js-cookie";
import { debounce } from "components/BasedTable/utils";
import { AppDispatch } from "store/store";
import { TickerItem } from "./TickerItem";
import EditCommentModal from "components/modals/AddCommentModal";

export const groups_list = ({
    data,
}: {
    data: {
        name: string | [string, boolean];
        id: number;
    }[];
}) => {
    const output = [];
    const default_group = data?.find((x) => x.name === "default");

    if (!default_group) {
        return [];
    }

    for (const item of data) {
        if (!item || item?.name === "default") {
            continue;
        }
        output.push(item);
    }

    const sortedOutput = output.sort((a, b) => {
        const nameA = Array.isArray(a.name) ? a.name[0] : a.name;
        const nameB = Array.isArray(b.name) ? b.name[0] : b.name;
        return String(nameA).localeCompare(String(nameB));
    });

    return default_group ? [default_group, ...sortedOutput] : sortedOutput;
};

const FIRST_ALERT_DELAY: number = 540_000; // 9 min
const SECOND_ALERT_DELAY: number = 60_000; // 1 min

const SavedSettingsBlock = ({
    setPendingApplyType,
    setSelectedConfigIds,selectedConfigIds,
    applyFiles,
    setIsApplyConfigModalOpen,
    getAutofillWarnings,
    setAutofillWarnings,
    autofillWarnings,
    isAreYouSureModalOpen,
    setIsAreYouSureModalOpen,
    setApplyConfigModalTitle,
    setApplicableGroup,
    setApplicableTicker,
    applicableTicker,
    applicableGroup,
}) => {
    const { groups, activeGroupTickers, groupsLoading, tickersLoading } =
        useAppSelector((state) => state.groups);

    const {
        activeGroup,
        isChanged,
        activeTicker,
        isNewTickerAdding,
        error,
        configFilesDetails,
        configs,
    } = useAppSelector((state) => state.settings);
    const { name: groupName } = activeGroup;
    const dispatch = useDispatch();
    const appDispatch = useDispatch<AppDispatch>();

    // const [pickedGroupId, setPickedGroupId] = useState("default")
    // const [pickedTickerName, setPickedTickerName] = useState("Название тикера")
    const [processingGroupName, setProcessingGroupName] = useState("");
    const [processingGroupId, setProcessingGroupId] = useState(-1);
    const [processingTicker, setProcessingTicker] = useState<{
        schedule_id: string;
        index: number;
        name: string;
    }>({ schedule_id: "", index: -1, name: "" });
    const [commentModalData, setCommentModalData] = useState<{
        tickerName: string;
        groupName: string;
        initialComment: string;
    } | null>(null);
    const [areYouSureMessage, setAreYouSureMessage] = useState<
        undefined | string
    >(undefined);
    const [areYouSureType, setAreYouSureType] = useState("");

    const [newGroupModalOpened, setNewGroupModalOpened] = useState(false);
    const [addTickerModalOpened, setAddTickerModalOpened] = useState(false);

    const [combineLogsModalOpen, setCombineLogsModalOpen] = useState(false);
    const [isGroupsExpanded, setIsGroupsExpanded] = useState(true);

    const [searchGroupString, setSearchGroupString] = useState("");
    const [searchTickerString, setSearchTickerString] = useState("");

    const { selectedRobotId } = useAppSelector((state) => state.robots);
    const [isWarningEditSessionOpen, setIsWarningEditSessionOpen] =
        useState(false);
    const [isExitEditSessionOpen, setIsExitEditSessionOpen] = useState(false);
    const firstTimerRef = useRef<number | undefined>(undefined);
    const secondTimerRef = useRef<number | undefined>(undefined);

    const unblockTickerOnLeave = (body: any) => {
        fetch(`${pathname}/api/unblock`, {
            keepalive: true,
            method: "POST",
            headers: {
                Authorization: `Bearer ${Cookies.get("access")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
    };

    const startTimer = () => {
        firstTimerRef.current = +setTimeout(() => {
            setIsWarningEditSessionOpen(true);

            secondTimerRef.current = +setTimeout(() => {
                setIsWarningEditSessionOpen(false);
                localStorage.setItem("autoExitFromEditSession", "yes");
                window.location.reload();
            }, SECOND_ALERT_DELAY);
        }, FIRST_ALERT_DELAY);
    };

    useEffect(() => {
        if (localStorage.getItem("autoExitFromEditSession")) {
            setIsExitEditSessionOpen(true);
            localStorage.removeItem("autoExitFromEditSession");
        }
    }, []);
    useEffect(() => {
        if (localStorage.getItem("autoExitFromEditSession")) {
            setIsExitEditSessionOpen(true);
            localStorage.removeItem("autoExitFromEditSession");
        }
    }, []);
    useEffect(() => {
        if (processingGroupName) {
            document.addEventListener("mousemove", handleMouseMoveEvent);
        }
        return () => {
            clearTimeout(firstTimerRef.current);
            clearTimeout(secondTimerRef.current);
            document.removeEventListener("mousemove", handleMouseMoveEvent);
        };
    }, [processingGroupName]);

    useEffect(() => {
        if (!selectedRobotId) return;
        dispatch(getGroups());
    }, [selectedRobotId]);

    useEffect(() => {
        if (groups?.length === 0 || !groups) return;
        // const [defaultGroup] = groups
        // const {name, id} = defaultGroup
        // dispatch(setSelectedGroup({name, id}))
        // dispatch(getTickersByGroup(name))
    }, [groups]);

    useEffect(() => {
        function innerFunc() {
            const clouserName = activeTicker.name;
            const clouserError = error;

            const requestBody = {
                blockIt: false,
                group_name: activeGroup.name,
                ticker_name: clouserName,
            };

            if (clouserName === "Название тикера" || clouserError !== null) {
                return;
            } else {
                unblockTickerOnLeave(requestBody);
            }
        }

        window.addEventListener("unload", innerFunc);

        return () => {
            window.removeEventListener("unload", innerFunc);
        };
    }, [activeGroup.name, activeTicker.name, error]);

    const onWarningModalClose = () => {
        setIsWarningEditSessionOpen(false);
        clearTimeout(secondTimerRef.current);
        handleMouseMoveEvent(); // in case when user click on button without moving a mouse
    };

    const onExitModalClose = () => {
        localStorage.removeItem("autoExitFromEditSession");
        setIsExitEditSessionOpen(false);
    };

    const handleMouseMoveEvent = () => {
        // we are disposing previous timeout and immediately creating a new one
        // eventually, we'll have only one timer left
        clearTimeout(firstTimerRef.current);

        startTimer();
    };

    const handleApplyGroupClick = (groupName: string) => {
        setApplicableGroup(groupName);

        const warnings = getAutofillWarnings();

        // setAutofillWarnings(warnings);
        // setIsAreYouSureModalOpen(true);
        // setAreYouSureMessage(
        //     'Тикеры данной группы заменят тикеры в группе "Текущая"',
        // );
        // setAreYouSureType("applyGroup");
        setAutofillWarnings(warnings);
        setPendingApplyType("applyGroup");
        setSelectedConfigIds(applyFiles?.map((f) => f.id) || []);
        setIsApplyConfigModalOpen(true);
        setApplyConfigModalTitle(
            'Тикеры данной группы заменят тикеры в группе "Текущая"',
        );
    };

    const handleApplyTickerClick = (ticker: {
        tickerName: string;
        schedule_id: string;
        index: number;
    }) => {
        setApplicableTicker(ticker);
        const warnings = getAutofillWarnings();
        setAutofillWarnings(warnings);

        // setIsAreYouSureModalOpen(true);
        // setAreYouSureMessage('Данный тикер будет включен в группу "Текущая"');
        // setAreYouSureType("applyTicker");
        setApplyConfigModalTitle(
            'Данный тикер будет включен в группу "Текущая"',
        );
        setPendingApplyType("applyTicker");
        setSelectedConfigIds(applyFiles?.map((f) => f.id) || []);
        setIsApplyConfigModalOpen(true);
    };

    const handleDeleteGroupClick =
        (name: string, type: "group" | "ticker", scheduleId?, index?) => () => {
            setIsAreYouSureModalOpen(true);
            if (type === "group") {
                setProcessingGroupName(name);
                setAreYouSureMessage("Группа будет удалена");
                setAreYouSureType("deleteGroup");
            } else if (type === "ticker") {
                setProcessingTicker({ name, schedule_id: scheduleId, index });
                setAreYouSureMessage("Тикер будет удален из текущей группы");
                setAreYouSureType("deleteTicker");
            }
        };

    const handleCopyClick =
        (name: string, type: "group" | "ticker", scheduleId?, index?) => () => {
            setIsAreYouSureModalOpen(true);
            if (type === "group") {
                setProcessingGroupName(name);
                setAreYouSureMessage(
                    `Будет создана копия группы ${
                        Array.isArray(name) ? name[0] : name
                    }`,
                );
                setAreYouSureType("copyGroup");
            } else if (type === "ticker") {
                setProcessingTicker({ name, schedule_id: scheduleId, index });
                setAreYouSureMessage(`Будет создана копия тикера ${name}`);
                setAreYouSureType("copyTicker");
            }
        };

    const handleSaveLogsTickerClick = (tickerName: string) => {
        setCombineLogsModalOpen(true);
        dispatch(setLogsTickerName(tickerName));
    };

    const handleGroupClick = (name: string, id: number) => {
        // setPickedGroupId(() => name)
        if (isNewTickerAdding) {
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Осуществить переход в другую группу? Все текущие изменения будут потеряны",
            );
            setAreYouSureType("changeGroup");
            setProcessingGroupName(name);
            setProcessingGroupId(id);
        } else {
            if (activeTicker.name !== "Название тикера" && error === null) {
                dispatch(
                    changeTickerBlockStatus({
                        blockIt: false,
                        group: activeGroup.name,
                        ticker: activeTicker.name,
                    }),
                );
            }
            groupChangeApplyFunc(name, id);
        }
    };

    const handleTickerClick = (
        tickerName: string,
        scheduleId: string,
        index: number,
    ) => {
        const isCurrentNewTicker =
            activeTicker.isNew && activeTicker.name !== "Название тикера";
        if (isCurrentNewTicker) {
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Если вы перейдёте, текущий несохранённый тикер будет удалён.\nНесохранённые изменения будут потеряны.",
            );
            setAreYouSureType("discardNewTicker");
            setProcessingTicker({
                name: tickerName,
                schedule_id: scheduleId,
                index,
            });
            return;
        }
        if (activeTicker.name !== "Название тикера" && error === null) {
            dispatch(
                changeTickerBlockStatus({
                    blockIt: false,
                    group: activeGroup.name,
                    ticker: activeTicker.name,
                }),
            );
        }
        tickerApplyFunc(tickerName, scheduleId, index);
    };

    const tickerApplyFunc = (tickerName: string, schedule_id, index) => {
        // setPickedTickerName(tickerName)
        if (groupName === "default") {
            dispatch(getLogsStatus(tickerName));
        }
        dispatch(setSelectedTicker({ name: tickerName, schedule_id, index }));
        dispatch(getTickerSettings());
        dispatch(setLogsTickerName(tickerName));
    };

    const groupChangeApplyFunc = (name, id) => {
        // setPickedTickerName(tickerName)
        setProcessingGroupName(name);
        setProcessingGroupId(id);
        dispatch(setSelectedGroup({ name, id }));
        // dispatch(clearActiveGroupTickers());
        // dispatch(getTickersByGroup(name));
        dispatch(resetTickerSettings());
        // dispatch(getTickersByGroup(name));
    };

    const handleSearchGroup = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchGroupString(e.target.value);
    };

    const [searchingForAddTickers, setSearchingForAddTickers] = useState([]);

    const debouncedSearch = useCallback(
        debounce(async (query: string, groupName: string) => {
            const { tickers } = await performSearch(query, groupName);
            setSearchingForAddTickers(tickers);
            setSearchTickerString(query);
        }, 300),
        [activeGroup.name],
    );

    const performSearch = async (query: string, groupName: string) => {
        if (query === "") return { tickers: [] };

        const searchResult = await appDispatch(
            searchTickers({
                group_name: groupName,
                query: query,
            }) as any,
        ).unwrap();

        return { tickers: searchResult };
    };

    const handleSearchTicker = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (value === "") {
            setSearchTickerString("");
            setSearchingForAddTickers([]);
            debouncedSearch.cancel();
            return;
        }

        if (activeGroup.id != -1) debouncedSearch(value, activeGroup.name);
    };
    const handleExpandClick = () => {
        setIsGroupsExpanded((prevState) => !prevState);
    };

    const handleAddTickerParamsButtonClick = () => {
        if (activeGroup.name === "Группа") {
            errorNotification("Выберите группу, чтобы добавить тикер");
        } else if (!isChanged && !isNewTickerAdding) {
            // dispatch(clearActiveGroupTickers());
            // dispatch(getTickersByGroup(activeGroup.name));
            setAddTickerModalOpened(true);
        } else {
            setAreYouSureType("openAddTickerModal");
            setIsAreYouSureModalOpen(true);
            setAreYouSureMessage(
                "Вызвать окно добавления нового тикера? Все текущие изменения будут потеряны",
            );
        }
    };

    const handleAreYouSureApplyFunc = (type: string) => {
        switch (type) {
            default:
                return () => setIsAreYouSureModalOpen(false);

            case "applyGroup":
                return () => {
                    dispatch(applyGroup(applicableGroup));
                    setIsAreYouSureModalOpen(false);
                };

            case "copyGroup":
                return () => {
                    const groupNames = groups.map((g) =>
                        Array.isArray(g.name) ? g.name[0] : g.name,
                    );
                    const newName = copyName(processingGroupName, groupNames);
                    dispatch(
                        copyGroup({
                            groupCopyName: newName,
                            groupName: processingGroupName,
                        }),
                    );
                    setIsAreYouSureModalOpen(false);
                };

            case "deleteGroup":
                return () => {
                    dispatch(deleteGroup(processingGroupName));
                    setIsAreYouSureModalOpen(false);
                };

            case "applyTicker":
                return () => {
                    dispatch(
                        applyTicker({
                            tickerName: applicableTicker.tickerName,
                            schedule_id: applicableTicker.schedule_id,
                            index: applicableTicker.index,
                            config_ids: selectedConfigIds,
                        }),
                    );
                    setIsAreYouSureModalOpen(false);
                };

            case "copyTicker":
                return () => {
                    dispatch(
                        copyTicker({
                            name: processingTicker.name,
                            schedule_id: processingTicker.schedule_id,
                            index: processingTicker.index,
                        }) as any,
                    )
                        .then((result) => {
                            if (copyTicker.fulfilled.match(result)) {
                                dispatch(getTickersByGroup(activeGroup.name));
                                setIsAreYouSureModalOpen(false);
                            } else {
                                errorNotification(
                                    (result.payload as string) ||
                                        "Ошибка копирования",
                                );
                                setIsAreYouSureModalOpen(false);
                            }
                        })
                        .catch((err) => {
                            console.error("❌ Copy ticker failed:", err);
                            errorNotification("Не удалось скопировать тикер");
                        });
                };

            case "deleteTicker":
                return () => {
                    const isNewUnsavedTicker =
                        activeTicker.isNew &&
                        processingTicker.name === activeTicker.name;

                    if (isNewUnsavedTicker) {
                        // Новый несохранённый тикер
                        dispatch(
                            resetTicker({ ticker_name: processingTicker.name }),
                        );
                        dispatch(getTickersByGroup(activeGroup.name));
                    } else {
                        // Обычный тикер
                        dispatch(
                            deleteTickerFromGroup({
                                tickerName: processingTicker.name,
                                scheduleId: processingTicker.schedule_id,
                                index: processingTicker.index,
                            }),
                        );
                        dispatch(
                            resetTicker({ ticker_name: processingTicker.name }),
                        );
                    }

                    setIsAreYouSureModalOpen(false);
                    setProcessingTicker({
                        schedule_id: "",
                        index: -1,
                        name: "",
                    });
                };
            case "discardNewTicker":
                return () => {
                    dispatch(resetTicker({ ticker_name: activeTicker.name }));
                    dispatch(getTickersByGroup(activeGroup.name));

                    setIsAreYouSureModalOpen(false);

                    if (
                        areYouSureType === "discardNewTicker" &&
                        processingGroupName
                    ) {
                        groupChangeApplyFunc(
                            processingGroupName,
                            processingGroupId,
                        );
                    } else if (processingTicker.name) {
                        tickerApplyFunc(
                            processingTicker.name,
                            processingTicker.schedule_id,
                            processingTicker.index,
                        );
                    }

                    setProcessingGroupName("");
                    setProcessingGroupId(-1);
                    setProcessingTicker({
                        schedule_id: "",
                        index: -1,
                        name: "",
                    });
                };
            case "changeTicker":
                return () => {
                    tickerApplyFunc(
                        processingTicker.name,
                        processingTicker.schedule_id,
                        processingTicker.index,
                    );
                    setIsAreYouSureModalOpen(false);
                    if (
                        activeTicker.name !== "Название тикера" &&
                        error === null
                    ) {
                        dispatch(
                            changeTickerBlockStatus({
                                blockIt: false,
                                group: activeGroup.name,
                                ticker: activeTicker.name,
                            }),
                        );
                    }
                };

            case "changeGroup":
                return () => {
                    groupChangeApplyFunc(
                        processingGroupName,
                        processingGroupId,
                    );
                    setIsAreYouSureModalOpen(false);
                };

            case "openAddTickerModal":
                return () => {
                    // dispatch(getTickersByGroup(activeGroup.name));
                    setAddTickerModalOpened(true);
                    setIsAreYouSureModalOpen(false);
                };
        }
    };

    useEffect(() => {
        if (!searchTickerString.trim()) {
            setSearchingForAddTickers([]);
            return;
        }

        performSearch(searchTickerString, activeGroup.name).then(
            ({ tickers }) => {
                setSearchingForAddTickers(tickers);
            },
        );
    }, [activeGroup.name, searchTickerString]);
    useEffect(() => {
        debouncedSearch.cancel();
    }, [activeGroup.name, debouncedSearch]);

    const selectedSCId = useAppSelector((store) => store.settings.selectedSCId);
    const openCommentModal = useCallback(
        (ticker: any) => {
            console.log("openCommentModal вызван с:", ticker);

            setCommentModalData({
                tickerName:
                    ticker?.ticker_name || ticker?.name || String(ticker),
                groupName: activeGroup.name,
                initialComment: ticker?.comment || "",
            });
        },
        [activeGroup.name],
    );
    let groupsList = groups_list({ data: groups?.slice() });

    groupsList = groupsList
        ?.filter(({ name }) => {
            const displayName =
                name === "default"
                    ? "Текущая"
                    : Array.isArray(name)
                      ? name[0]
                      : name;
            return displayName
                .toLowerCase()
                .includes(searchGroupString.toLowerCase());
        })
        .map(({ name, id }, index) => {
            let displayName = "";
            let isCurrentGroup = false;
            let isCurrent = false;
            if (name === "default") {
                displayName = "Текущая";
                isCurrentGroup = true;
            } else if (Array.isArray(name) && name[1] === true) {
                displayName = `${name[0]} (t)`;
                isCurrent = true;
            } else if (typeof name === "string") {
                displayName = name;
            } else {
                return null;
            }
            return (
                <TickerItem
                    // norm
                    key={`${name}-${id}`}
                    isCurrent={isCurrent}
                    name={displayName}
                    isCurrentGroup={isCurrentGroup}
                    onClick={() => handleGroupClick(name, id)}
                    isSelected={activeGroup.name === name}
                    onCheckboxClick={() => handleApplyGroupClick(name)}
                    onCopyClick={handleCopyClick(
                        name,
                        "group",
                        name.schedule_id,
                        name.index,
                    )}
                    onDeleteClick={handleDeleteGroupClick(name, "group")}
                />
            );
        });

    const groupTickersList = activeGroupTickers
        ?.filter((obj) => {
            return obj.name.ticker_name?.includes(searchTickerString);
        })
        ?.sort()
        ?.map(({ name }) => {
            const ticker_name = name.ticker_name;
            const croppedName = ticker_name ? ticker_name : "Неизвестный тикер";
            const uniqueKey = `${name.ticker_name}-${name.schedule_id}-${name.index}`;

            if (selectedSCId !== null) {
                if (name.schedule_id === selectedSCId)
                    return (
                        <>
                            <TickerItem
                                groupName={groupName}
                                fullName={name}
                                key={uniqueKey}
                                name={croppedName}
                                onClick={() => {
                                    handleTickerClick(
                                        croppedName,
                                        name.schedule_id,
                                        name.index,
                                    );
                                }}
                                isSelected={
                                    activeTicker.name === croppedName &&
                                    activeTicker.schedule_id ===
                                        name.schedule_id &&
                                    activeTicker.index === name.index
                                }
                                isTicker
                                onCheckboxClick={() =>
                                    handleApplyTickerClick({
                                        tickerName: ticker_name,
                                        schedule_id: name.schedule_id,
                                        index: name.index,
                                    })
                                }
                                onCopyClick={handleCopyClick(
                                    croppedName,
                                    "ticker",
                                    name.schedule_id,
                                    name.index,
                                )}
                                onDeleteClick={handleDeleteGroupClick(
                                    croppedName,
                                    "ticker",
                                    name.schedule_id,
                                    name.index,
                                )}
                                onSaveLogsClick={() =>
                                    handleSaveLogsTickerClick(croppedName)
                                }
                                tickerName={activeTicker.name}
                                onCommentClick={openCommentModal}
                            />
                        </>
                    );
            } else
                return (
                    <TickerItem
                        groupName={groupName}
                        key={name.index + "-" + name.ticker_name}
                        name={croppedName}
                        onClick={() => {
                            handleTickerClick(
                                croppedName,
                                name.schedule_id,
                                name.index,
                            );
                        }}
                        isSelected={
                            activeTicker.name === croppedName &&
                            activeTicker.schedule_id === name.schedule_id &&
                            activeTicker.index === name.index
                        }
                        isTicker
                        tickerName={name}
                        onCheckboxClick={() =>
                            handleApplyTickerClick({
                                tickerName: ticker_name,
                                schedule_id: name.schedule_id,
                                index: name.index,
                            })
                        }
                        onCopyClick={handleCopyClick(
                            croppedName,
                            "ticker",
                            name.schedule_id,
                            name.index,
                        )}
                        onDeleteClick={handleDeleteGroupClick(
                            croppedName,
                            "ticker",
                            name.schedule_id,
                            name.index,
                        )}
                        onSaveLogsClick={() =>
                            handleSaveLogsTickerClick(croppedName)
                        }
                        onCommentClick={openCommentModal}
                    />
                );
        });

    const includeInApplyNames = Object.values(configFilesDetails)
        .filter((el) => el.include_in_apply)
        .map((el) => el.name);

    const listTitleApplyNames = `Будут перенесены следующие файлы:\n${includeInApplyNames.join("\n")}`;

    return (
        <>
            <ModalContentWrapper>
                <TickersSelectWrapper>
                    <TopElementsDiv>
                        <TickersTitle>
                            {isGroupsExpanded && <TitleText>Группы</TitleText>}
                            <CustomArrowExpand onClick={handleExpandClick} />
                            {isGroupsExpanded && (
                                <CustomPlusCircled
                                    onClick={() => setNewGroupModalOpened(true)}
                                />
                            )}
                        </TickersTitle>
                        {isGroupsExpanded && (
                            <SearchInput
                                onChange={handleSearchGroup}
                                type="text"
                                placeholder={"Поиск"}
                            />
                        )}
                    </TopElementsDiv>
                    <SelectDiv
                        renderThumbVertical={(props) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    borderRadius: "10px",
                                    left: "1",
                                    zIndex: 2,
                                }}
                            />
                        )}
                    >
                        {!groupsLoading &&
                            groups?.length > 0 &&
                            isGroupsExpanded &&
                            groupsList}
                        {groupsLoading && groups?.length === 0 && (
                            <Loader size="large" />
                        )}
                    </SelectDiv>
                </TickersSelectWrapper>
                <TickersSelectWrapper>
                    <TopElementsDiv>
                        <TickersTitle>
                            Тикеры
                            <div style={{ display: "flex", gap: "3px" }}>
                                <CustomPlusCircled
                                    onClick={handleAddTickerParamsButtonClick}
                                />
                            </div>
                        </TickersTitle>
                        <SearchInput
                            onChange={handleSearchTicker}
                            type="text"
                            placeholder={"Поиск"}
                        />
                    </TopElementsDiv>
                    <SelectDiv
                        id={`ticker-items-wrapper`}
                        renderThumbVertical={(props) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    borderRadius: "10px",
                                    left: "1",
                                    zIndex: 2,
                                }}
                            />
                        )}
                    >
                        {tickersLoading && <Loader size="large" />}
                        {searchingForAddTickers.length != 0 &&
                            searchingForAddTickers.map((tickerName) => {
                                const croppedName = tickerName.ticker_name
                                    ? tickerName.ticker_name
                                    : "Неизвестный тикер";
                                const unicKey = `${tickerName.ticker_name}-${tickerName.schedule_id}-${tickerName.index}`;

                                return (
                                    <>
                                        <TickerItem
                                            groupName={groupName}
                                            key={unicKey}
                                            name={croppedName}
                                            onClick={() => {
                                                handleTickerClick(
                                                    croppedName,
                                                    tickerName.schedule_id,
                                                    tickerName.index,
                                                );
                                            }}
                                            isSelected={
                                                activeTicker.name ===
                                                croppedName
                                            }
                                            isTicker
                                            tickerName={tickerName}
                                            onCommentClick={openCommentModal}
                                            onCheckboxClick={() =>
                                                handleApplyTickerClick({
                                                    tickerName: tickerName.name,
                                                    schedule_id:
                                                        tickerName.schedule_id,
                                                    index: tickerName.index,
                                                })
                                            }
                                            onCopyClick={handleCopyClick(
                                                croppedName,
                                                "ticker",
                                                tickerName.schedule_id,
                                                tickerName.index,
                                            )}
                                            onDeleteClick={handleDeleteGroupClick(
                                                croppedName,
                                                "ticker",
                                            )}
                                            onSaveLogsClick={() =>
                                                handleSaveLogsTickerClick(
                                                    croppedName,
                                                )
                                            }
                                        />
                                    </>
                                );
                            })}
                        {!tickersLoading &&
                            activeGroupTickers &&
                            !searchingForAddTickers.length &&
                            groupTickersList}
                    </SelectDiv>
                </TickersSelectWrapper>
            </ModalContentWrapper>
            {newGroupModalOpened && (
                <NewGroupModal
                    isOpen={newGroupModalOpened}
                    onRequestClose={() => setNewGroupModalOpened(false)}
                />
            )}
            {
                <AddTickerModal
                    isOpen={addTickerModalOpened}
                    onRequestClose={() => setAddTickerModalOpened(false)}
                />
            }
            {isAreYouSureModalOpen && (
                <AreYouSureModal
                    title={"Вы уверены?"}
                    description={areYouSureMessage}
                    listItems={autofillWarnings}
                    listTitle={listTitleApplyNames}
                    isOpen={isAreYouSureModalOpen}
                    onRequestClose={() => {
                        setIsAreYouSureModalOpen(false);
                        setAutofillWarnings([]);
                    }}
                    onApplyClick={handleAreYouSureApplyFunc(areYouSureType)}
                />
            )}
            {combineLogsModalOpen && (
                <CombineLogsModal
                    isOpen={combineLogsModalOpen}
                    onRequestClose={() => setCombineLogsModalOpen(false)}
                />
            )}
            <WarningEditSessionModal
                isOpen={isWarningEditSessionOpen}
                onRequestClose={onWarningModalClose}
            />
            <ExitEditSessionModal
                isOpen={isExitEditSessionOpen}
                onRequestClose={onExitModalClose}
            />
            {commentModalData && (
                <EditCommentModal
                    isOpen={!!commentModalData}
                    onRequestClose={() => setCommentModalData(null)}
                    tickerName={commentModalData.tickerName}
                    groupName={commentModalData.groupName}
                    initialComment={commentModalData.initialComment}
                />
            )}
        </>
    );
};

export default SavedSettingsBlock;
